import {
  IFileData,
  ISQLSeedingTranslator,
} from '@principle-theorem/practice-migrations/interfaces';
import { IProvider } from '@principle-theorem/shared';

export class PraktikaAppointmentPaymentsTranslator
  implements ISQLSeedingTranslator, IProvider<IFileData, string[]>
{
  matchingFilenames = ['appointment_payments.csv'];
  commands = [`sed -i -e 's/vchResponseText/vchResponseText2/2'`];

  canProvide(data: IFileData): boolean {
    return this.matchingFilenames.includes(data.fileName);
  }

  execute(data: IFileData): string[] {
    return this.commands.map((cmd) => `${cmd} ${data.filePath}`);
  }
}
